import ProdConfig from './ProdConfig';
import DevConfig from './DevConfig';

const OVERRIDE_CONFIG = process.env.NODE_ENV === 'development' ? DevConfig : ProdConfig;

window.__CONFIG__ = window.__CONFIG__ || {};

export default {
  STRIPE_PUBLIC_KEY: window.__CONFIG__.STRIPE_PUBLIC_KEY,
  SENTRY_DSN: window.__CONFIG__.SENTRY_DSN,
  MIXPANEL_TOKEN: window.__CONFIG__.MIXPANEL_TOKEN,
  SENTRY_VERSION: window.__CONFIG__.SENTRY_VERSION,
  RECAPTCHA_KEY: window.__CONFIG__.RECAPTCHA_KEY,
  CSRF_COOKIE_NAME: window.__CONFIG__.CSRF_COOKIE_NAME,
  VETTING_SIGNUP_MAX_NUM_OF_SEATS: window.__CONFIG__.VETTING_SIGNUP_MAX_NUM_OF_SEATS,
  SEF_PRO_TRIAL_DAYS: window.__CONFIG__.SEF_PRO_TRIAL_DAYS,
  CHANGE_LANGUAGE_PATH: window.__CONFIG__.CHANGE_LANGUAGE_PATH,
  USAGE_ANALYTICS_ENABLED: window.__CONFIG__.USAGE_ANALYTICS_ENABLED,
  AUDIT_LOG_ENABLED: window.__CONFIG__.AUDIT_LOG_ENABLED,
  ACTIVATION_LINKS_ENABLED: window.__CONFIG__.ACTIVATION_LINKS_ENABLED,
  HELP_LINK: window.__CONFIG__.HELP_LINK,
  API_HELP_LINK: window.__CONFIG__.API_HELP_LINK,
  APP_URI_PREFIX: window.__CONFIG__.APP_URI_PREFIX,
  ACCOUNTS_PREFIX: process.env.NODE_ENV === 'development' ? '' : 'accounts/',
  TERMS_AND_CONDITIONS_URL_SEARCH_UI: window.__CONFIG__.TERMS_AND_CONDITIONS_URL_SEARCH_UI,
  TERMS_AND_CONDITIONS_URL_SEARCH_API: window.__CONFIG__.TERMS_AND_CONDITIONS_URL_SEARCH_API,
  TERMS_AND_CONDITIONS_URL_VERIFY_API: window.__CONFIG__.TERMS_AND_CONDITIONS_URL_VERIFY_API,
  MAX_DAYS_TO_DISPLAY_SI_DOCS_BANNER: window.__CONFIG__.MAX_DAYS_TO_DISPLAY_SI_DOCS_BANNER,
  SI_DOCS_BANNER_VISIBLE: window.__CONFIG__.SI_DOCS_BANNER_VISIBLE,
  SI_DOCS_LINK: window.__CONFIG__.SI_DOCS_LINK,
  API_USAGE_URL: window.__CONFIG__.API_USAGE_URL,
  INSIGHTS_SEARCH_HISTORY_URL: window.__CONFIG__.INSIGHTS_SEARCH_HISTORY_URL,
  ...OVERRIDE_CONFIG,
};
